import MapPreview from './MapPreview';

export default MapPreview;
